module.exports = __webpack_public_path__ + "static/media/white_category_icon_c4.a52f11f6.svg";